import React, { useState, useEffect, useRef } from 'react';
import { useSession } from '@clerk/clerk-react';

// Loading overlay component for session transitions
const SessionTransitionOverlay = () => (
  <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-gray-900 text-white">
    <div className="mb-8 text-center">
      <svg className="w-16 h-16 mx-auto mb-4 text-blue-400 filter drop-shadow-[0_0_8px_rgba(59,130,246,0.5)] animate-pulse" viewBox="0.00 0.00 1024.00 1024.00" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M 690.43 147.34 C 712.23 158.92 727.32 179.19 732.81 202.98 C 733.92 207.79 733.96 211.47 734.63 216.10 Q 734.82 217.40 734.75 221.40 Q 733.98 262.15 702.78 288.31 C 683.27 304.66 657.91 310.13 632.96 305.55 C 603.60 300.15 580.68 280.59 569.84 252.90 Q 560.19 228.25 566.46 201.45 Q 571.65 179.27 588.27 162.28 Q 609.04 141.06 640.73 137.00 Q 642.78 136.74 651.57 136.90 Q 657.89 137.01 662.36 137.83 Q 677.94 140.70 690.43 147.34 Z"/>
        <path d="M 600.71 431.49 A 0.39 0.39 0.0 0 0 599.98 431.43 Q 598.53 434.71 595.85 439.37 Q 577.61 471.07 528.88 554.52 A 0.89 0.88 -53.2 0 0 529.03 555.61 Q 531.65 558.11 535.18 561.01 Q 564.45 585.03 622.72 634.51 Q 636.24 645.99 639.58 650.98 Q 647.78 663.26 647.60 678.18 Q 647.52 685.35 644.40 695.38 Q 625.49 756.27 590.89 867.18 C 583.52 890.81 559.07 905.19 535.19 896.49 C 515.56 889.34 503.67 868.27 509.40 847.41 Q 510.54 843.28 512.45 837.16 Q 541.83 743.04 551.68 710.69 Q 555.42 698.40 558.72 688.87 A 0.79 0.78 -61.1 0 0 558.48 688.02 C 511.75 649.33 475.47 618.94 433.58 585.51 C 431.31 583.70 429.21 581.57 426.71 579.19 Q 411.38 564.56 407.44 543.81 Q 407.10 542.06 406.45 536.46 Q 405.94 532.16 406.19 529.04 Q 407.32 514.84 412.95 505.43 Q 455.03 435.10 501.88 355.25 A 0.45 0.45 0.0 0 0 501.61 354.59 L 430.72 335.53 A 0.91 0.91 0.0 0 0 429.90 335.72 C 421.79 342.81 415.34 349.09 407.71 356.07 Q 374.05 386.85 336.32 422.04 C 334.32 423.90 332.28 425.38 330.43 427.03 Q 329.09 428.21 327.94 428.87 Q 317.11 435.07 305.98 433.87 Q 291.81 432.36 283.20 422.47 C 271.24 408.73 270.80 389.09 282.66 375.10 Q 283.94 373.60 288.06 369.55 Q 295.65 362.10 335.91 325.16 Q 366.46 297.13 389.34 275.91 Q 397.82 268.05 401.44 266.04 Q 407.80 262.51 416.25 261.04 Q 418.36 260.67 424.84 260.85 Q 428.43 260.95 433.32 262.06 Q 441.85 263.99 442.00 264.03 Q 485.43 275.16 537.13 288.86 Q 548.24 291.80 568.18 296.70 Q 587.87 301.53 595.00 304.97 Q 618.44 316.24 630.63 339.12 Q 644.12 364.44 687.18 449.07 A 0.73 0.73 0.0 0 0 687.90 449.45 Q 695.94 448.59 704.29 448.19 Q 713.88 447.72 720.75 447.21 Q 749.42 445.09 755.51 444.80 C 757.90 444.69 760.97 444.05 763.51 444.07 C 769.80 444.10 775.56 442.94 781.33 442.93 C 784.72 442.92 789.73 442.05 793.56 442.62 C 809.32 444.98 819.92 455.21 823.82 470.70 Q 824.21 472.23 824.08 479.25 Q 824.00 483.59 822.59 487.62 Q 816.19 505.94 796.96 511.64 Q 793.24 512.74 780.73 513.12 A 13.48 12.95 -23.1 0 0 778.84 513.31 C 774.83 514.00 770.86 513.88 767.16 514.21 Q 757.75 515.05 742.81 515.94 C 737.36 516.26 732.89 517.08 727.35 517.07 C 724.85 517.07 722.49 517.85 719.93 517.89 Q 713.36 518.00 709.15 518.54 C 704.79 519.10 699.95 518.78 695.74 519.53 C 691.56 520.27 688.08 519.85 683.78 520.39 C 675.94 521.37 665.90 521.77 658.73 519.51 Q 644.45 515.01 637.19 501.53 Q 622.99 475.17 601.53 433.86 Q 601.06 432.95 600.71 431.49 Z"/>
        <path d="M 391.27 548.22 C 397.03 578.68 419.25 598.11 443.95 614.55 A 0.68 0.68 0.0 0 1 443.99 615.65 Q 443.80 615.79 443.69 615.93 Q 419.16 648.70 379.29 703.78 Q 378.79 704.47 374.51 709.00 Q 363.45 720.70 347.36 722.76 Q 342.62 723.36 333.75 723.30 Q 314.98 723.17 194.00 723.24 C 189.09 723.24 183.01 722.16 178.25 719.98 Q 161.09 712.13 155.62 694.13 C 149.33 673.44 160.29 650.61 181.53 644.40 Q 186.30 643.00 197.11 643.01 Q 292.37 643.09 324.15 643.02 A 0.56 0.53 16.7 0 0 324.60 642.79 L 390.20 547.99 A 0.60 0.59 56.9 0 1 391.27 548.22 Z"/>
      </svg>
      <h2 className="text-xl font-semibold text-blue-400 mb-2">Runium</h2>
    </div>
    
    <div className="flex flex-col items-center space-y-4">
      <div className="flex items-center justify-center">
        <div className="relative">
          <div className="w-8 h-8 border-2 border-blue-400/30 rounded-full"></div>
          <div className="absolute top-0 left-0 w-8 h-8 border-2 border-blue-400 border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
      <p className="text-gray-300 text-sm">Switching accounts...</p>
      <div className="flex items-center justify-center space-x-1">
        <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
        <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '0.1s' }}></div>
        <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
      </div>
    </div>
  </div>
);

export default function MultisessionAppSupport({ children }) {
  const { session } = useSession();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [stableSessionId, setStableSessionId] = useState(session?.id || 'no-users');
  const previousSessionIdRef = useRef(session?.id || 'no-users');
  const transitionTimeoutRef = useRef(null);

  useEffect(() => {
    const currentSessionId = session?.id || 'no-users';
    
    // If session ID changed, start transition
    if (currentSessionId !== previousSessionIdRef.current) {
      setIsTransitioning(true);
      
      // Clear any existing timeout
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
      
      // Show transition for a short period to allow for smooth change
      transitionTimeoutRef.current = setTimeout(() => {
        setStableSessionId(currentSessionId);
        previousSessionIdRef.current = currentSessionId;
        
        // Brief additional delay to ensure smooth transition
        setTimeout(() => {
          setIsTransitioning(false);
        }, 300);
      }, 500); // Show transition for 500ms
    }

    return () => {
      if (transitionTimeoutRef.current) {
        clearTimeout(transitionTimeoutRef.current);
      }
    };
  }, [session?.id]);

  // Show transition overlay during session changes
  if (isTransitioning) {
    return <SessionTransitionOverlay />;
  }

  // This fragment's key changes only after the transition is complete,
  // providing a smoother experience when switching sessions
  return (
    <React.Fragment key={stableSessionId}>
      {children}
    </React.Fragment>
  );
} 